import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Modal,
  Button,
  Upload,
  Table,
} from "antd";
import {
  LoadingOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import { ColaIcon } from "./../../assets/icons";
import { useModalDirectLinkContext } from "components/ModalDirectLink";
import { XLSX_TYPE } from "constants/excelFileType";
import { handleParse } from "hooks/FileHandler";
import _ from "lodash";
import BasicButtonPrimary from "components/BasicButtonPrimary";

const SAMPLE_IMPORT_FILE_LINK = `${process.env.PUBLIC_URL}/import/file_mau_import_danh_sach_khach_hang.xlsx`;

const ModalUpload = ({
  visible,
  toggleUploadModal,
  onUploadFile,
  file,
  onImportFileToDb,
  isLoading,
  dataFilter,
  columns,
  upload,
  setUpload,
  onClearUpload,
}) => {
  const [selectingTemplateType, setSelectingTemplateType] = useState([]);
  const [previewColumns, setPreviewColumns] = useState([]);
  const [date, setDate] = useState("DD/MM/YYYY");
  const [totalExcel, setTotalExcel] = useState(0);
  const { t: translation } = useTranslation();
  const { setUrlForModalDirectLink } = useModalDirectLinkContext();

  useEffect(() => {}, []);

  const getPreviewColumns = (columnCount) => {
    const dataColumns = columns.filter(
      (column) =>
        column.dataIndex && column.dataIndex !== "customerRecordId"
    );

    return Array.from({ length: columnCount }, (_, index) => {
      const sourceColumn = index === 0 ? undefined : dataColumns[index - 1];
      const dataIndex =
        index === 0
          ? "customerIndex"
          : sourceColumn?.dataIndex || `excelColumn${index}`;

      return {
        ...sourceColumn,
        title: index === 0 ? "STT" : sourceColumn?.title || `Cột ${index + 1}`,
        dataIndex,
        key: dataIndex,
        width: Number.parseFloat(sourceColumn?.width) || 180,
        render: (value) => value,
      };
    });
  };

  const showPreview = (previewData, nextPreviewColumns) => {
    setSelectingTemplateType(previewData);
    setPreviewColumns(nextPreviewColumns);
    setUpload(true);
    onUploadFile();
    setTotalExcel(previewData.length);
  };

  const handleClearPreview = () => {
    setSelectingTemplateType([]);
    setPreviewColumns([]);
    setTotalExcel(0);
    setUpload(false);
    onClearUpload();
  };

  const handleUploadChange = _.debounce(async (info) => {
    const selectedFile = info.file.originFileObj || info.file;
    const excelRows = await handleParse(selectedFile, false);
    const rows = excelRows.filter((row) =>
      row.some((value) => value !== undefined && value !== null && value !== "")
    );
    const columnCount = rows.reduce(
      (maxColumnCount, row) => Math.max(maxColumnCount, row.length),
      0
    );
    const nextPreviewColumns = getPreviewColumns(columnCount);
    const previewData = rows.map((row) => {
      return nextPreviewColumns.reduce((record, column, index) => {
        record[column.dataIndex] = row[index] ?? "";
        return record;
      }, {});
    });

    showPreview(previewData, nextPreviewColumns);
  }, 500);

  return (
    <Modal
      width={1000}
      height={500}
      visible={visible}
      title={translation("listCustomers.upload_customer_list")}
      onCancel={toggleUploadModal}
      footer={
        <div className="d-flex justify-content-center">
          <BasicButtonPrimary
            disabled={!!!file}
            onclick={() => onImportFileToDb(selectingTemplateType)}
            text={translation("listCustomers.importFile")}
          />
        </div>
      }
    >
      <div className="">{isLoading && <LoadingOutlined />}</div>
      <div className="d-flex justify-content-center align-items-center" style={{flexWrap:'wrap',textAlign:'center',gap:'10%'}}>
        {upload === false ? (
          <>
            <div>
              <div className="upload-type">
                {translation("listCustomers.uploadType")}
              </div>
              <div className="updoad mb-4 d-block">
                <div className="righta">
                  <p>
                    {translation("listCustomers.downloadTemplateFileTitle")}
                  </p>
                  <BasicButtonPrimary 
                    text={translation("listCustomers.downloadSampleFile")} 
                    icon={<ColaIcon />} 
                    onclick={() => setUrlForModalDirectLink(SAMPLE_IMPORT_FILE_LINK)}
                    className="d-flex align-items-center justify-content-center gap-2"
                    />
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="d-flex align-items-center gap-3">
            <div>Tổng số dòng excel : {totalExcel}</div>
            <Button danger onClick={handleClearPreview}>
              Xoá dữ liệu
            </Button>
          </div>
        )}
      </div>
      <div className="borderBottom">
        {upload === false ? (
          <Upload.Dragger
            maxCount={1}
            accept={XLSX_TYPE}
            showUploadList={true}
            multiple={false}
            onChange={handleUploadChange}
            beforeUpload={() => false}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text text-danger">
              Số lượng dòng tối đa có thể import: 30,000 dòng
            </p>
            <p className="ant-upload-text">
              Click hoặc kéo thả để tải file lên
            </p>
          </Upload.Dragger>
        ) : (
          <>
            <Table
              dataSource={selectingTemplateType}
              columns={previewColumns}
              rowKey={(_, index) => index}
              tableLayout="fixed"
              scroll={{
                x: previewColumns.reduce(
                  (totalWidth, column) => totalWidth + column.width,
                  0
                ),
              }}
              pagination={true}
            />
          </>
        )}
      </div>
    </Modal>
  );
};

export default ModalUpload;
